import { chunk, flatten } from 'lodash-es';
import { QRY_CHAIN_COUP_INFO } from '../../config/url';
import { handleFormatRes, request, RespError, utf8to16 } from '../../utils';
/** 分组每页大小 */
const SLICE_PAGE_SIZE = 1;
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'dispatchCount',
    'expireDay',
    'perCount',
    'recivedNum',
    'totalCount',
    'totalNum',
    'index',
    'transState',
    'dispatchCount',
    'totalCount',
];
// 需要转成 date 型的 key 数组
const needParseDateKey = [
    'expireTime',
    'receiveTime',
    'sysTime',
    'validTime',
];
// 需要转成以元为单位的key数组
const needFen2YuanKey = [
    'discount', 'requiredNum',
];
const transformer = (res) => {
    for (const [key, value] of Object.entries(res.couponList)) {
        if (key === 'couponName') {
            // 需要特殊处理优惠券名称
            res.data[key] = decodeURIComponent(escape(value));
        }
    }
    return res;
};
/**
 * 查询连锁券使用情况, actListId支持传入任意数量条数据，会自动分页查询
 *
 * 查询连锁活动优惠券信息，用户使用情况、券信息等
 *
 * 接口地址：`/app/promotion/prom_qry_combincoup_info.cgi`
 *
 * @param
 * @returns
 */
export async function qryChainCoupInfo({ actListId }) {
    const chunkActListId = chunk(actListId, SLICE_PAGE_SIZE);
    const res = await Promise.all(chunkActListId.map(ids => sliceQryChainCoupInfo({ actListId: ids })));
    const resCouponList = flatten(res.map(resItem => resItem.couponList));
    const resCouponArr = flatten(res.map(resItem => resItem.couponArr));
    const returnRes = Object.assign(Object.assign({}, res === null || res === void 0 ? void 0 : res[0]), { couponList: resCouponList, couponArr: resCouponArr });
    return returnRes;
}
/**
 * 连锁券查询接口
 * @param param0 actListId[]
 */
export async function sliceQryChainCoupInfo({ actListId }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_listid: actListId[0],
        };
        // 接口请求
        const result = await request.get(QRY_CHAIN_COUP_INFO, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                result.coupon_list = JSON.parse(utf8to16(atob(result.coupon_list)));
                const formattedRes = handleFormatRes({
                    result, needParseIntKey, needParseDateKey, needFen2YuanKey, transformer
                });
                // TODO: 待确认，该接口最多可以传多少个actListIds
                return formattedRes;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
